<template>
    <div class="consultas-produtos-cliente">
        <g-card class="card-consultas-produtos-cliente" :expansivel="false" :temCabecalho="false">
            <div class="header-detalhes-secundario">
                <div class="header-detalhes-secundario-titulo">
                    <g-button
                    class="buscar-button-header"
                    icone="icone_voltar.svg"
                    altura="30px"
                    largura="35px"
                    tamanhoIcone="10px"
                    cor="#FFFFFF"
                    negritoTexto
                    :sombreado="false"
                    @click="voltar()"
                    >
                    </g-button> 
                    <div class="titulo-detalhes-cabecalho"> Detalhes do Cliente </div>
                </div>
            </div>

            <div class="conteudo-detalhes-cliente espacamento-detalhes">
                <div class="dados-cliente-titulo titulo-grupo-detalhes"> DADOS DO CLIENTE </div>
                <div class="grupo-dados-cliente">
                    <div class="cliente-unidade">
                        <div class="titulo-conteudo-detalhes"> Unidade </div>
                        <div class="label-conteudo">{{ InformacoesClienteSelecionado.nomeEmpresa }}</div>
                    </div>

                    <div class="cliente-representante">
                        <div class="titulo-conteudo-detalhes"> Vendedor / Representante </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.nomeRepresentante}}</div>
                    </div>

                    <div class="cliente-razao-social">
                        <div class="titulo-conteudo-detalhes"> Razão Social </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.razaoSocial}}</div>
                    </div>
                        
                    <div class="cliente-inscricao">
                        <div class="dados_cliente_inscricao titulo-conteudo-detalhes"> Inscrição estadual</div>
                        <div class="dados_cliente_inscricao_label-conteudo label-conteudo">{{InformacoesClienteSelecionado.inscricaoEstadual || 'Não Cadastrado'}}</div>
                    </div>

                    <div class="cliente-cnpj">
                        <div class="titulo-conteudo-detalhes"> CNPJ </div>
                        <PInputMask v-model="InformacoesClienteSelecionado.cnpj " mask="99.999.999/9999-99" class="input-mask-escondido">  </PInputMask>
                        <div class="label-conteudo"  mask="99.999.999/9999-99">{{InformacoesClienteSelecionado.cnpj}}</div>
                    </div>

                    <div class="cliente-nome-fantasia">
                        <div class="titulo-conteudo-detalhes"> Nome Fantasia </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.nomeFantasia}}</div>
                    </div>

                    <div class="cliente-situacao">
                        <div class="titulo-conteudo-detalhes"> Situação </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.clienteSituacaoTexto}}</div>
                    </div>

                    <div class="cliente-segmento">
                        <div class="titulo-conteudo-detalhes"> Segmento </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.clienteTipoTexto}}</div>
                    </div>

                    <div class="cliente-curva">
                        <div class="titulo-conteudo-detalhes"> CV </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.curvaCliente || 'Não Possui'}}</div>
                    </div>

                    <div class="cliente-email">
                        <div class="titulo-conteudo-detalhes"> E-mail Nfe </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.emailNFE || 'Não cadastrado'}}</div>
                    </div>

                    <div class="cliente-cidade-estado">
                        <div class="titulo-conteudo-detalhes"> Cidade / Estado </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.estadoCidade}}</div>
                    </div>
                </div>

                <div class="dados-fiscais-titulo titulo-grupo-detalhes"> DADOS FISCAIS </div>
                <div class="grupo-dados-fiscais">
                    <div class="fiscais-agrupador">
                        <div class="titulo-conteudo-detalhes"> Cliente agrupador </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.nomeClienteAgrupador}}</div>
                    </div>
    
                    <div class="fiscais-suframa">
                        <div class="titulo-conteudo-detalhes"> Suframa </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.numeroSuframa == 0 ? 'Não Possui' : InformacoesClienteSelecionado.numeroSuframa}}</div>
                    </div>

                    <div class="fiscais-suspensao-ipi">
                        <div class="titulo-conteudo-detalhes"> Possui suspensão de IPI? </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.ipi ? 'Possui' : 'Não Possui'}}</div>
                    </div>

                    <div class="fiscais-zona-franca">
                        <div class="titulo-conteudo-detalhes"> Zona Franca </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.zonaFranca ? 'Possui' : 'Não Possui' }}</div>
                    </div>

                    <div class="fiscais-codigo-acesso">
                        <div class="titulo-conteudo-detalhes"> Exige código de acesso na nota fiscal? </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.exigeOrdemAcessoNaNF ? 'Sim' : 'Não'}}</div>
                    </div>

                    <div class="fiscais-incentivo-icms">
                        <div class="titulo-conteudo-detalhes"> Possui incentivo fiscal - Diferimento de ICMS?</div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.icms ? 'Sim' : 'Não'}}</div>
                    </div>

                    <div class="fiscais-ordem-compra">
                        <div class="titulo-conteudo-detalhes"> Exige ordem de compra na nota fiscal? </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.exigeOrdemCompraNaNF ? 'Sim' : 'Não'}}</div>
                    </div>

                    <div class="fiscais-incentivo-pis">
                        <div class="titulo-conteudo-detalhes"> Possui incentivo fiscal - Diferimento de PIS/COFINS? </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.pisCofins ? 'Sim' : 'Não' }}</div>
                    </div>

                    <div class="fiscais-quantidade">
                        <div class="titulo-conteudo-detalhes"> Quantidade </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.quantidade}}</div>
                    </div>
                </div>
    
                <div class="dados-contato-titulo titulo-grupo-detalhes edita-titulo-grupo"> CONTATO </div>
                <div class="grupo-dados-contato" v-for="contato in InformacoesClienteSelecionado.contatos" :key="contato.id">
                    <div class="contato-telefone">
                        <div class="titulo-conteudo-detalhes"> Nome Contato </div>
                        <div class="label-conteudo">{{ contato.nomeContato || 'Não Cadastrado'}}</div>                    
                    </div>
                    <div class="contato-telefone">
                        <div class="titulo-conteudo-detalhes"> Nome Função </div>
                        <div class="label-conteudo">{{ contato.nomeFuncao || 'Não Cadastrado'}}</div>                    
                    </div>
                    <div class="contato-telefone">
                        <div class="titulo-conteudo-detalhes"> Telefone </div>
                        <div class="label-conteudo">{{ contato.numeroTelefone || 'Não Cadastrado'}}</div>                    
                    </div>

                    <div class="contato-celular">
                        <div class="titulo-conteudo-detalhes"> Celular </div>
                        <div class="label-conteudo">{{ contato.numeroCelular|| 'Não Cadastrado' }}</div>
                    </div>

                    <div class="contato-email">
                        <div class="titulo-conteudo-detalhes"> Email </div>
                        <div class="label-conteudo">{{ contato.email || 'Não Cadastrado' }}</div>
                    </div>

                    <div class="contato-site">
                        <div class="titulo-conteudo-detalhes"> Site </div>
                        <div class="label-conteudo">{{ contato.clienteSite || 'Não Cadastrado' }}</div>
                    </div>
                </div>

                <div class="cliente-label label-conteudo" v-if="!this.TemInformacoesContato"> Cliente não possui nenhum contato cadastrado </div>
  
                <div class="dados-endereco-titulo titulo-grupo-detalhes edita-titulo-grupo"> ENDEREÇO </div>
                <div class="grupo-dados-endereco" v-for="enderecos in InformacoesClienteSelecionado.enderecos" :key="enderecos.id">
                    <div class="endereco-endereco">
                        <div class="titulo-conteudo-detalhes"> Endereço </div>
                        <div class="label-conteudo">{{ enderecos.endereco  || 'Não cadastrado'}}</div>
                    </div>

                    <div class="endereco-cidade-estado">
                        <div class="titulo-conteudo-detalhes"> Cidade / Estado </div>
                        <div class="label-conteudo">{{enderecos.nomeCidade}} - {{enderecos.siglaEstado}}</div>
                    </div>

                    <div class="endereco-bairro">
                        <div class="titulo-conteudo-detalhes"> Bairro </div>
                        <div class="label-conteudo">{{ enderecos.bairro || 'Não Cadastrado'}}</div>
                    </div>

                    <div class="endereco-cep">
                        <div class="titulo-conteudo-detalhes"> CEP </div>
                        <div class="label-conteudo">{{ enderecos.cep}}</div>
                    </div>

                    <div class="endereco-complemento">
                        <div class="titulo-conteudo-detalhes">Complemento</div>
                        <div class="label-conteudo">{{ enderecos.complemento || 'Não Cadastrado'}}</div>
                    </div>
                </div>      

                <div class="cliente-label label-conteudo" v-if="!this.TemInformacoesEndereco"> Não há endereços cadastrados para este cliente! </div>
                
                <div class="dados-credito-titulo titulo-grupo-detalhes"> CRÉDITO </div>
                <div class="grupo-dados-credito" v-if="this.TemInformacoesCredito">
                    <div class="credito-ultima-compra">
                        <div class="titulo-conteudo-detalhes"> Última compra </div>
                        <div class="label-conteudo">{{(InformacoesClienteCreditoSelecionado.dataUltimoFaturamentoFormatada || ' ')+ ' - ' + 'R$ ' + (InformacoesClienteCreditoSelecionado.valorUltimoFaturamentoFormatado || '0,00')}}</div>
                    </div>

                    <div class="credito-ultimo-pagamento">
                        <div class="titulo-conteudo-detalhes"> Último pagamento </div>
                        <div class="label-conteudo">{{(InformacoesClienteCreditoSelecionado.dataUltimoPagamentoFormatada || '  ' )+ ' - ' + 'R$ ' + (InformacoesClienteCreditoSelecionado.valorUltimoPagamentoFormatado || '0,00')}}</div>
                    </div>

                    <div class="credito-maior-faturamento">
                        <div class="titulo-conteudo-detalhes"> Maior faturamento </div>
                        <div class="label-conteudo">{{( InformacoesClienteCreditoSelecionado.dataMaiorFaturamentoFormatada || '  ' ) + ' - ' + 'R$ ' + (InformacoesClienteCreditoSelecionado.valorMaiorFaturamentoFormatada || '0,00')}}</div>
                    </div>

                    <div class="credito-maior-acumulo">
                        <div class="titulo-conteudo-detalhes"> Maior acúmulo </div>
                        <div class="label-conteudo">{{( InformacoesClienteCreditoSelecionado.dataMaiorAcumuloFormatada || '  ' ) + ' - ' + 'R$ ' + (InformacoesClienteCreditoSelecionado.valorMaiorAcumuloFormatado || '0,00') }}</div>
                    </div>

                    <div class="credito-titulos-aberto">
                        <div class="titulo-conteudo-detalhes"> Títulos em aberto </div>
                        <div class="label-conteudo">{{'R$ ' + (InformacoesClienteCreditoSelecionado.valorTitulosEmAbertoFormatado || '0,00') }}</div>
                    </div>

                    <div class="credito-titulos-vencidos">
                        <div class="titulo-conteudo-detalhes"> Títulos vencidos </div>
                        <div class="label-conteudo">{{'R$ ' + (InformacoesClienteCreditoSelecionado.valorTitulosVencidosFormatado || '0,00')}}</div>
                    </div>

                    <div class="credito-titulos-vencer">
                        <div class="titulo-conteudo-detalhes"> Títulos à vencer </div>
                        <div class="label-conteudo">{{'R$ ' + (InformacoesClienteCreditoSelecionado.valorTitulosAVencerFormatado || ' ')}}</div>
                    </div>

                    <div class="credito-titulos-protestados">
                        <div class="titulo-conteudo-detalhes"> Possui títulos protestados </div>
                        <div class="label-conteudo">{{InformacoesClienteCreditoSelecionado.titulosProtestados == false ? 'Não' : 'Sim'}}</div>
                    </div>

                    <div class="credito-parcelas-dia">
                        <div class="titulo-conteudo-detalhes"> Parcelas pagas em dia </div>
                        <div class="label-conteudo">{{InformacoesClienteCreditoSelecionado.diasParcelasPagas}}</div>
                    </div>

                    <div class="credito-parcelas-atraso">
                        <div class="titulo-conteudo-detalhes"> Parcelas pagas em atraso </div>
                        <div class="label-conteudo">{{InformacoesClienteCreditoSelecionado.diasParcelasAtraso}}</div>
                    </div>

                    <div class="credito-media-atraso">
                        <div class="titulo-conteudo-detalhes"> Média de atraso </div>
                        <div class="label-conteudo">{{InformacoesClienteCreditoSelecionado.quantidadeDiasAtrasoMedio}}</div>
                    </div>

                    <div class="credito-pedidos-aberto">
                        <div class="titulo-conteudo-detalhes"> Pedidos em aberto </div>
                        <div class="label-conteudo">{{'R$ ' + (InformacoesClienteCreditoSelecionado.valorPedidosEmCarteiraFormatado || '0,00')}}</div>
                    </div>

                    <div class="credito-valor-limite">
                        <div class="titulo-conteudo-detalhes"> Valor do limite de crédito </div>
                        <div class="label-conteudo">{{'R$ ' + (InformacoesClienteCreditoSelecionado.valorLimiteCreditoFormatado || '0,00')}}</div>
                    </div>

                    <div class="credito-data-atualizacao">
                        <div class="titulo-conteudo-detalhes"> Data atualização </div>
                        <div class="label-conteudo">{{InformacoesClienteCreditoSelecionado.alteracaoFormatada || 'Não Possui'}}</div>
                    </div>

                    <div class="credito-data-validade-limite">
                        <div class="titulo-conteudo-detalhes"> Data da validade do limite de crédito </div>
                        <div class="label-conteudo">{{InformacoesClienteCreditoSelecionado.dataValidadeLimiteCreditoFormatada || 'Não Possui'}}</div>
                    </div>

                    <div class="credito-observacao">
                        <div class="titulo-conteudo-detalhes"> Observação </div>
                        <div class="label-conteudo">{{InformacoesClienteCreditoSelecionado.observacao || 'Não Possui'}}</div>
                    </div>
                </div>

                <div v-if="!this.TemInformacoesCredito" class="cliente-label label-conteudo"> Cliente não possui informações de crédito </div>
            </div>
        </g-card>
    </div>
</template>

<script>
import Cliente from "./ClienteInformacoes.js";

export default Cliente;
</script>

<style scoped>
.input-mask-escondido{
    display: none;
}

    hr:not([size]) {
        height: 1px;
        margin-top: 38px;
    }

.cliente-label {
    margin-top: 10px;
}

.grupo-dados-contato, .grupo-dados-endereco {
    display: flex;
    flex-wrap: wrap;
    column-gap: 50px;
    border-top: 1px solid #f0f0f0;
    padding: 5px 0 10px;
}

.edita-titulo-grupo {
  border-bottom: none;
}

@media (min-width:310px) {
.grupo-dados-cliente {
    display: grid;
    grid-template-columns: repeat(2, minmax(4em, 1fr));
    grid-template-rows: repeat(10, auto);
    grid-column-gap: 20px;
}

.cliente-unidade { grid-area: 1 / 1 / 2 / 3; }
.cliente-representante { grid-area: 2 / 1 / 3 / 3; }
.cliente-razao-social { grid-area: 3 / 1 / 4 / 3; }
.cliente-inscricao { grid-area: 4 / 1 / 5 / 3; }
.cliente-cnpj { grid-area: 5 / 1 / 6 / 3; }
.cliente-nome-fantasia { grid-area: 6 / 1 / 7 / 3; }
.cliente-situacao { grid-area: 7 / 1 / 8 / 3; }
.cliente-segmento { grid-area: 8 / 1 / 9 / 2; }
.cliente-curva { grid-area: 8 / 2 / 9 / 3; }
.cliente-email { grid-area: 9 / 1 / 10 / 3; }
.cliente-cidade-estado { grid-area: 10 / 1 / 11 / 3; }
}

@media (min-width:368px) {
}

@media (min-width:450px) {
.grupo-dados-fiscais {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(5, auto);
    grid-column-gap: 20px;
}

.fiscais-agrupador { grid-area: 1 / 1 / 2 / 2; }
.fiscais-suframa { grid-area: 1 / 2 / 2 / 3; }
.fiscais-suspensao-ipi { grid-area: 2 / 1 / 3 / 2; }
.fiscais-zona-franca { grid-area: 2 / 2 / 3 / 3; }
.fiscais-codigo-acesso { grid-area: 3 / 1 / 4 / 2; }
.fiscais-incentivo-icms { grid-area: 3 / 2 / 4 / 3; }
.fiscais-ordem-compra { grid-area: 4 / 1 / 5 / 2; }
.fiscais-incentivo-pis { grid-area: 4 / 2 / 5 / 3; }
.fiscais-quantidade { grid-area: 5 / 1 / 6 / 2; }


.grupo-dados-credito {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(8, auto);
    grid-column-gap: 20px;
}

.credito-ultima-compra { grid-area: 1 / 1 / 2 / 2; }
.credito-ultimo-pagamento { grid-area: 1 / 2 / 2 / 3; }
.credito-maior-faturamento { grid-area: 2 / 1 / 3 / 2; }
.credito-maior-acumulo { grid-area: 2 / 2 / 3 / 3; }
.credito-titulos-aberto { grid-area: 3 / 1 / 4 / 2; }
.credito-titulos-vencidos { grid-area: 3 / 2 / 4 / 3; }
.creditos-titulos-vencer { grid-area: 4 / 1 / 5 / 2; }
.creditos-titulos-protestados { grid-area: 4 / 2 / 5 / 3; }
.credito-parcelas-dia { grid-area: 5 / 1 / 6 / 2; }
.credito-parcelas-atraso { grid-area: 5 / 2 / 6 / 3; }
.credito-media-atraso { grid-area: 6 / 1 / 7 / 2; }
.credito-pedidos-aberto { grid-area: 6 / 2 / 7 / 3; }
.credito-valor-limite { grid-area: 7 / 1 / 8 / 2; }
.credito-data-atualizacao { grid-area: 7 / 2 / 8 / 3; }
.credito-data-validade-limite { grid-area: 8 / 1 / 9 / 2; }
.credito-observacao { grid-area: 8 / 2 / 9 / 3; }
}

@media (min-width:600px) {
.grupo-dados-cliente {
    grid-template-rows: repeat(6, auto);
}

.cliente-unidade { grid-area: 1 / 1 / 2 / 2; }
.cliente-representante { grid-area: 1 / 2 / 2 / 3; }
.cliente-razao-social { grid-area: 2 / 1 / 3 / 2; }
.cliente-inscricao { grid-area: 2 / 2 / 3 / 3; }
.cliente-cnpj { grid-area: 3 / 1 / 4 / 2; }
.cliente-nome-fantasia { grid-area: 3 / 2 / 4 / 3; }
.cliente-situacao { grid-area: 4 / 1 / 5 / 2; }
.cliente-segmento { grid-area: 4 / 2 / 5 / 3; }
.cliente-curva { grid-area: 5 / 1 / 6 / 2; }
.cliente-email { grid-area: 5 / 2 / 6 / 3; }
.cliente-cidade-estado { grid-area: 6 / 1 / 7 / 2; }
}

@media (min-width:801px) {
.grupo-dados-cliente {
    grid-template-columns: repeat(3, minmax(4em, 1fr));
    grid-template-rows: repeat(4, auto);
}

.cliente-unidade { grid-area: 1 / 1 / 2 / 2; }
.cliente-representante { grid-area: 1 / 2 / 2 / 3; }
.cliente-razao-social { grid-area: 1 / 3 / 2 / 4; }
.cliente-inscricao { grid-area: 2 / 1 / 3 / 2; }
.cliente-cnpj { grid-area: 2 / 2 / 3 / 3; }
.cliente-nome-fantasia { grid-area: 2 / 3 / 3 / 4; }
.cliente-situacao { grid-area: 3 / 1 / 4 / 2; }
.cliente-segmento { grid-area: 3 / 2 / 4 / 3; }
.cliente-curva { grid-area: 3 / 3 / 4 / 4; }
.cliente-email { grid-area: 4 / 1 / 5 / 2; }
.cliente-cidade-estado { grid-area: 4 / 2 / 5 / 4; }


.grupo-dados-fiscais {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(5, auto);
}

.fiscais-agrupador { grid-area: 1 / 1 / 2 / 2; }
.fiscais-suframa { grid-area: 1 / 2 / 2 / 3; }
.fiscais-suspensao-ipi { grid-area: 1 / 3 / 2 / 4; }
.fiscais-zona-franca { grid-area: 2 / 1 / 3 / 2; }
.fiscais-codigo-acesso { grid-area: 2 / 2 / 3 / 3; }
.fiscais-incentivo-icms { grid-area: 2 / 3 / 3 / 4; }
.fiscais-ordem-compra { grid-area: 3 / 1 / 4 / 2; }
.fiscais-incentivo-pis { grid-area: 3 / 2 / 4 / 3; }
.fiscais-quantidade { grid-area: 3 / 3 / 4 / 4; }


.grupo-dados-credito {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(6, auto);
}

.credito-ultima-compra { grid-area: 1 / 1 / 2 / 2; }
.credito-ultimo-pagamento { grid-area: 1 / 2 / 2 / 3; }
.credito-maior-faturamento { grid-area: 1 / 3 / 2 / 4; }
.credito-maior-acumulo { grid-area: 2 / 1 / 3 / 2; }
.credito-titulos-aberto { grid-area: 2 / 2 / 3 / 3; }
.credito-titulos-vencidos { grid-area: 2 / 3 / 3 / 4; }
.creditos-titulos-vencer { grid-area: 3 / 1 / 4 / 2; }
.creditos-titulos-protestados { grid-area: 3 / 2 / 4 / 3; }
.credito-parcelas-dia { grid-area: 3 / 3 / 4 / 4; }
.credito-parcelas-atraso { grid-area: 4 / 1 / 5 / 2; }
.credito-media-atraso { grid-area: 4 / 2 / 5 / 3; }
.credito-pedidos-aberto { grid-area: 4 / 3 / 5 / 4; }
.credito-valor-limite { grid-area: 5 / 1 / 6 / 2; }
.credito-data-atualizacao { grid-area: 5 / 2 / 6 / 3; }
.credito-data-validade-limite { grid-area: 5 / 3 / 6 / 4; }
.credito-observacao { grid-area: 6 / 1 / 7 / 2; }
}

@media (min-width:1025px) { 

}

@media (min-width:1281px) { 
.grupo-dados-cliente {
    grid-template-columns: repeat(4, minmax(4em, 1fr));
    grid-template-rows: repeat(3, auto);
}

.cliente-unidade { grid-area: 1 / 1 / 2 / 2; }
.cliente-representante { grid-area: 1 / 2 / 2 / 3; }
.cliente-razao-social { grid-area: 1 / 3 / 2 / 4; }
.cliente-inscricao { grid-area: 1 / 4 / 2 / 5; }
.cliente-cnpj { grid-area: 2 / 1 / 3 / 2; }
.cliente-nome-fantasia { grid-area: 2 / 2 / 3 / 3; }
.cliente-situacao { grid-area: 2 / 3 / 3 / 4; }
.cliente-segmento { grid-area: 2 / 4 / 3 / 5; }
.cliente-curva { grid-area: 3 / 1 / 4 / 2; }
.cliente-email { grid-area: 3 / 2 / 4 / 3; }
.cliente-cidade-estado { grid-area: 3 / 3 / 4 / 4; }


.grupo-dados-fiscais {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(3, auto);
}

.fiscais-agrupador { grid-area: 1 / 1 / 2 / 2; }
.fiscais-suframa { grid-area: 1 / 2 / 2 / 3; }
.fiscais-suspensao-ipi { grid-area: 1 / 3 / 2 / 4; }
.fiscais-zona-franca { grid-area: 1 / 4 / 2 / 5; }
.fiscais-codigo-acesso { grid-area: 2 / 1 / 3 / 2; }
.fiscais-incentivo-icms { grid-area: 2 / 2 / 3 / 3; }
.fiscais-ordem-compra { grid-area: 2 / 3 / 3 / 4; }
.fiscais-incentivo-pis { grid-area: 2 / 4 / 3 / 5; }
.fiscais-quantidade { grid-area: 3 / 1 / 4 / 2; }


.grupo-dados-credito {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(4, auto);
}

.credito-ultima-compra { grid-area: 1 / 1 / 2 / 2; }
.credito-ultimo-pagamento { grid-area: 1 / 2 / 2 / 3; }
.credito-maior-faturamento { grid-area: 1 / 3 / 2 / 4; }
.credito-maior-acumulo { grid-area: 1 / 4 / 2 / 5; }
.credito-titulos-aberto { grid-area: 2 / 1 / 3 / 2; }
.credito-titulos-vencidos { grid-area: 2 / 2 / 3 / 3; }
.creditos-titulos-vencer { grid-area: 2 / 3 / 3 / 4; }
.creditos-titulos-protestados { grid-area: 2 / 4 / 3 / 5; }
.credito-parcelas-dia { grid-area: 3 / 1 / 4 / 2; }
.credito-parcelas-atraso { grid-area: 3 / 2 / 4 / 3; }
.credito-media-atraso { grid-area: 3 / 3 / 4 / 4; }
.credito-pedidos-aberto { grid-area: 3 / 4 / 4 / 5; }
.credito-valor-limite { grid-area: 4 / 1 / 5 / 2; }
.credito-data-atualizacao { grid-area: 4 / 2 / 5 / 3; }
.credito-data-validade-limite { grid-area: 4 / 3 / 5 / 4; }
.credito-observacao { grid-area: 4 / 4 / 5 / 5; }
}


@media (min-width:1700px) { 
}

@media (min-width:1800px) { 
.grupo-dados-cliente {
    grid-template-columns: repeat(5, minmax(4em, 1fr));
}

.cliente-unidade { grid-area: 1 / 1 / 2 / 2; }
.cliente-representante { grid-area: 1 / 2 / 2 / 3; }
.cliente-razao-social { grid-area: 1 / 3 / 2 / 4; }
.cliente-inscricao { grid-area: 1 / 4 / 2 / 5; }
.cliente-cnpj { grid-area: 1 / 5 / 2 / 6; }
.cliente-nome-fantasia { grid-area: 2 / 1 / 3 / 2; }
.cliente-situacao { grid-area: 2 / 2 / 3 / 3; }
.cliente-segmento { grid-area: 2 / 3 / 3 / 4; }
.cliente-curva { grid-area: 2 / 4 / 3 / 5; }
.cliente-email { grid-area: 2 / 5 / 3 / 6; }
.cliente-cidade-estado { grid-area: 3 / 1 / 4 / 2; }

.grupo-dados-credito {
    grid-template-columns: repeat(5, 1fr);
}

.credito-ultima-compra { grid-area: 1 / 1 / 2 / 2; }
.credito-ultimo-pagamento { grid-area: 1 / 2 / 2 / 3; }
.credito-maior-faturamento { grid-area: 1 / 3 / 2 / 4; }
.credito-maior-acumulo { grid-area: 1 / 4 / 2 / 5; }
.credito-titulos-aberto { grid-area: 1 / 5 / 2 / 6; }
.credito-titulos-vencidos { grid-area: 2 / 1 / 3 / 2; }
.creditos-titulos-vencer { grid-area: 2 / 2 / 3 / 3; }
.creditos-titulos-protestados { grid-area: 2 / 3 / 3 / 4; }
.credito-parcelas-dia { grid-area: 2 / 4 / 3 / 5; }
.credito-parcelas-atraso { grid-area: 2 / 5 / 3 / 6; }
.credito-media-atraso { grid-area: 3 / 1 / 4 / 2; }
.credito-pedidos-aberto { grid-area: 3 / 2 / 4 / 3; }
.credito-valor-limite { grid-area: 3 / 3 / 4 / 4; }
.credito-data-atualizacao { grid-area: 3 / 4 / 4 / 5; }
.credito-data-validade-limite { grid-area: 3 / 5 / 4 / 6; }
.credito-observacao { grid-area: 4 / 1 / 5 / 2; }
}
</style>

